const brandSubNav = 'BrandSubNavBreadcrumb'

const consts = {
  BRAND_SUB_NAV: brandSubNav,
  BRAND_SUB_NAV_DROPDOWN: `${brandSubNav}-dropdown`,
  BRAND_SUB_NAV_DROPDOWN_VISIBLE: `is-visible`,
  BRAND_SUB_NAV_DROPDOWN_HIDDEN: `is-hidden`,
  BRAND_SUB_NAV_CONTENT: `${brandSubNav}-content`,
  BRAND_SUB_NAV_CONTENT_TRIGGER: `${brandSubNav}-content-trigger`,
  BRAND_SUB_NAV_TAG_CLASS: 'sub-navigation-tag',
  BRAND_SUB_NAV_NAVTAG: `${brandSubNav}-dropdown-tag`,
  BRAND_SUB_NAV_NAVTAG_ACTIVE: `is-active`,
  BRAND_HEADER: 'BrandHeader',
  BRAND_HEADER_STATUS_CONTAINER: 'BrandHeader-status',
  BRAND_NAVIGATION_TOP_MENU_BAR: 'BrandNavigationTopMenu-bar',
  BRAND_TOPNAV_MENU_BAR_ANIM_UP: 'BrandNavigationTopMenu-bar--anim-up',
  BRAND_SUB_NAVIGATION_BREADCRUMB: `${brandSubNav}`,
  BRAND_NAVIGATON_TOP_MENU_BAR_VISIBILITY_BTN: 'BrandNavigationTopMenu-bar-visibilityBtn',
  BRAND_NAVIGATON_TOP_MENU_BAR_VISIBILITY_BTN_VISIBLE: `is-visible`,
  BRAND_NAVIGATION_TOP_MENU_LINK: 'BrandNavigationTopMenu-link',
  BRAND_SUB_NAV_ARROW_LEFT: '>',
  BRAND_SUB_NAV_SPAN: `${brandSubNav}-content-span`,
  BRAND_SUB_NAV_ANIM_UP: `${brandSubNav}--anim-up`
}

export { consts }



// WEBPACK FOOTER //
// ./src/components/sub-navigation/js/consts.js